import { FAIcon, Theme, TagStyle, Tag, SearchDataStructure, AttributeTypes } from '../../../ui/components';
import { GetColumnsType } from '../../../ui/components/TableContainer/types/propsTypes';
import { DynamicObjectInterface } from '../../../sdk/type';

export interface MasterData {
  campaign: {
    campaignEnd?: string;
    campaignId?: string;
    campaignName?: string;
    campaignStart: string;
    recId?: number;
    status?: string;
  }[];
  reward?: {
    recId: number;
    rewardCode: string;
    rewardName: string;
  }[];
}
export interface CampaignOption {
  campaignEnd: string;
  campaignId: string;
  campaignName: string;
  campaignStart: string;
  status: string;
  title: string;
  value: string;
}

export const dataSearchOption: SearchDataStructure[] = [
  {
    name: 'Location Name',
    key: 'locationName',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Reward Name',
    key: 'rewardName',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Stock Status',
    key: 'stockStatus',
    type: AttributeTypes.DropdownSingleSelect,
    visibility: true,
    dataset: [
      {
        key: 'NORMAL',
        value: 'NORMAL',
      },
      {
        key: 'LOW',
        value: 'LOW',
      },
    ],
  },
];

type IInventoryBO = {
  [key: string]: DynamicObjectInterface;
};

export const getInventoryListConfig: GetColumnsType = (
  styles: DynamicObjectInterface,
  translation: DynamicObjectInterface,
  cb: DynamicObjectInterface,
) => [
  {
    key: 'locationName',
    text: translation('admin.inventory.locationName'),
    width: 7,
    sortable: true,
    render: (object: IInventoryBO) => <span>{object.locationName}</span>,
  },
  {
    key: 'rewardName',
    text: translation('admin.inventory.rewardName'),
    width: 7,
    sortable: true,
    render: (object: IInventoryBO) => <span>{object.rewardName}</span>,
  },
  {
    key: 'totalStock',
    text: translation('admin.inventory.totalStock'),
    width: 2,
    sortable: true,
    render: (object: IInventoryBO) => (<span>{object.totalStock }</span>),
  },
  {
    key: 'availableStock',
    text: translation('admin.inventory.availableStock'),
    sortable: true,
    width: 2,
    render: (object: IInventoryBO) => (
      <span>
        <Tag
          theme={object.stockStatus === 'NORMAL' ? Theme.WHITE : Theme.RED}
          style={TagStyle.OUTLINE}
          text={object.availableStock}
        />
      </span>
    ),
  },
  {
    key: 'redeemedStock',
    text: translation('admin.inventory.redeemedStock'),
    sortable: true,
    width: 2,
    render: (object: IInventoryBO) => (<span>{object.redeemedStock }</span>),
  },
  {
    key: 'status',
    text: translation('admin.inventory.status'),
    sortable: true,
    width: 2,
    render: (object: IInventoryBO) => (
      <span>
        <Tag
          theme={object.status === 'ACTIVE' ? Theme.SUCCESS : Theme.WARNING}
          style={TagStyle.OUTLINE}
          text={object.status}
        />
      </span>
    ),
  },
  {
     key: 'action',
     width: 2,
     text: 'Actions',
     render: (object: IInventoryBO) => (
       <>
         <FAIcon
           iconName={'edit'}
           onClick={e => {
             cb?.onEdit(object.recId);
             e.stopPropagation();
           }}
           theme={Theme.PURPLE}
           title={'Edit'}
         />
         {' | '}
         <FAIcon
           iconName={'trash-can'}
           onClick={e => {
             cb?.onClick(object.recId);
             e.stopPropagation();
           }}
          style={{
            pointerEvents:
              object.isUnauthorized ? 'none' : 'auto',
              opacity: object.isUnauthorized ? 0.7 : 1,
          }}
          theme={
            object.isUnauthorized
              ? Theme.GRAY
              : Theme.PURPLE
          }
           title={'Delete'}
         />
       </>
     ),
   },
];

